import { createReducer, createAction } from "@reduxjs/toolkit";

export const actions = {
  request_access_token: createAction("REQUEST_ACCESS_TOKEN"),
  access_token_verified: createAction("ACCESS_TOKEN_VERIFIED"),
  access_token_has_insufficient_permission: createAction("ACCESS_TOKEN_HAS_INSUFFICIENT_PERMISSION"),
  request_access_token_failure: createAction("REQUEST_ACCESS_TOKEN_FAILURE"),
};

export const constants = {
  UNVERIFIED: "UNVERIFIED",
  LOADING: "LOADING",
  VERIFIED: "VERIFIED",
  INSUFFICIENT: "INSUFFICIENT",
  ERROR: "ERROR",
};

export const initState = {
  authState: constants.UNVERIFIED,
  accessToken: "",
};

export const actionsMap = {
  [actions.request_access_token]: (state) => {
    state.authState = constants.LOADING;
    return state;
  },
  [actions.access_token_verified]: (state, action) => {
    const { accessToken } = action.payload;
    state.accessToken = accessToken;
    state.authState = constants.VERIFIED;
    return state;
  },
  [actions.access_token_has_insufficient_permission]: (state) => {
    state.authState = constants.INSUFFICIENT;
    return state;
  },
  [actions.request_access_token_failure]: (state) => {
    state.authState = constants.ERROR;
    return state;
  },
};

export const reducer = createReducer(initState, actionsMap);

const getAuth = (state) => state.auth;
export const selectors = {
  getAuth,
};
